var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServe2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 60,
    viewBox: "0 0 73 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.2108 50.3799C48.5849 50.3799 46.4485 52.5163 46.4485 55.1423C46.4485 57.7681 48.5849 59.9045 51.2108 59.9045C53.8368 59.9045 55.9732 57.7681 55.9732 55.1423C55.9732 52.5163 53.8368 50.3799 51.2108 50.3799ZM52.2236 56.1545C51.9559 56.4206 51.5879 56.574 51.2099 56.574C50.8334 56.574 50.4654 56.4208 50.1977 56.1545C49.9313 55.8882 49.7782 55.5188 49.7782 55.1423C49.7782 54.7658 49.9313 54.3965 50.1977 54.13C50.464 53.8639 50.8334 53.7106 51.2099 53.7106C51.5879 53.7106 51.9557 53.8638 52.2236 54.13C52.4897 54.3963 52.6416 54.7658 52.6416 55.1423C52.6416 55.5188 52.4899 55.8882 52.2236 56.1545Z",
    fill: "#5B21FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9936 15.0065L46.4917 0L37.2125 9.70397L42.5129 15.0065H58.9936Z",
    fill: "#5B21FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6605 2.20337L12.8575 15.0064H38.4635L25.6605 2.20337Z",
    fill: "#5B21FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7892 50.3799C19.1632 50.3799 17.0268 52.5163 17.0268 55.1423C17.0268 57.7681 19.1632 59.9045 21.7892 59.9045C24.4151 59.9045 26.5515 57.7681 26.5515 55.1423C26.5516 52.5163 24.4151 50.3799 21.7892 50.3799ZM22.8006 56.1545C22.5344 56.4206 22.1664 56.574 21.7899 56.574C21.4119 56.574 21.0427 56.4208 20.7763 56.1545C20.51 55.8882 20.3568 55.5188 20.3568 55.1423C20.3568 54.7658 20.5098 54.3965 20.7763 54.13C21.0425 53.8639 21.4119 53.7106 21.7899 53.7106C22.1664 53.7106 22.5344 53.8638 22.8006 54.13C23.0683 54.3963 23.2215 54.7658 23.2215 55.1423C23.2216 55.5188 23.0683 55.8882 22.8006 56.1545Z",
    fill: "#5B21FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21564 32.107H66.7844L68.0461 25.7842H4.95395L6.21564 32.107Z",
    fill: "#5B21FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0529 17.8806C62.0523 17.8806 62.0517 17.8806 62.0513 17.8806C62.0509 17.8806 62.0504 17.8806 62.05 17.8806H9.40206C9.40134 17.8806 9.40062 17.8806 9.3999 17.8806H0V22.7664H73V17.8806H62.0529Z",
    fill: "#5B21FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5744 53.8058H14.2866C14.9284 50.2132 18.0471 47.5358 21.7892 47.5358C25.5312 47.5358 28.6499 50.2132 29.2917 53.8058H43.7083C44.3501 50.2132 47.4688 47.5358 51.2108 47.5358C54.9528 47.5358 58.0717 50.2132 58.7134 53.8058H62.4256L66.2109 34.981H6.78915L10.5744 53.8058Z",
    fill: "#5B21FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServe2);
export default __webpack_public_path__ + "static/media/serve2.2d1a9994c7186ee79a2f358a08b2b492.svg";
export { ForwardRef as ReactComponent };